import React from 'react';

import {Button} from 'antd';
import { FormattedMessage } from 'react-intl';

import {ShareIcon, MailIcon} from '../academy.svg';

import { academyConst } from '../academy';

import { format } from '../functions';

const CustomLayout = (props) => {
    const {displayLayout, activeLesson, lessons=[], changeState, state, percent, setPercent, currentTime} = props;

    const handleOnClick = (item) => {
            let notCompleteLessons = [...state.timeOfNotFinishedLessons];
            const activeNotFinishedItem = state.timeOfNotFinishedLessons.filter(x => x.id === item.id);
            if(percent < 100){
                const index = notCompleteLessons.findIndex(x => x.id === state.activeLessonKey);
                if(index === -1){
                    notCompleteLessons.push({
                        id: state.activeLessonKey,
                        percent,
                        time: currentTime
                    })
                }else{
                    notCompleteLessons.splice(index, 1, {
                        id: state.activeLessonKey,
                        percent,
                        time: currentTime
                    })
                }
            }

            changeState({
                activeLesson: item, 
                activeLessonKey: item.id, 
                timeOfNotFinishedLessons: [...notCompleteLessons],
            });

            setPercent(activeNotFinishedItem[0] ? activeNotFinishedItem[0]['percent'] : 0);
    }

    return(
        <div className={displayLayout ? "onpause" : "notonpause"}>
            <div className="video_list">
            {lessons.filter(x => x.id !== activeLesson.id).map((item,i) => (
                <div className="item" onClick={() => handleOnClick(item)} key={item.id}>
                    <div className="title">{item.title}</div>
                    <img key={item.id} src={`https://img.youtube.com/vi/${item.video_id}/default.jpg`} alt="academy youtube preview"/>
                    <div className="time">{format(item.video_duration)}</div>
                </div>
            ))}
            </div>
            <div className="write_to_us">
                <Button
                    className="write_to_us_btn"
                    size="large"
                    onClick={() => changeState({writeToUsModalShow: true})}
                >
                    <span>
                        <FormattedMessage id="Write to us" defaultMessage="Write to us"/>
                    </span>
                    <MailIcon width="20px" height="20px"/>
                </Button>
                <Button
                    className="write_to_us_btn"
                    size="large"
                    onClick={() => changeState({
                        shareModalShow: true,
                        shareType: academyConst.LESSON
                    })}
                >
                    <span>
                        <FormattedMessage id="Share" defaultMessage="Share" />
                    </span>
                    <ShareIcon width="20px" height="20px"/>
                </Button>
            </div>
        </div>
    )
}











export default CustomLayout;